module.exports = __webpack_public_path__ + "static/media/techwatch.d33058bb.png";